import React from 'react';
import { Redirect } from 'react-router-dom';

import { getRouteFor, routeNaming } from '../../routes';

const GoToNotFound = () => (
  <Redirect to={getRouteFor(routeNaming.NOT_FOUND)} />
);

export { GoToNotFound };



// WEBPACK FOOTER //
// ./src/pages/go-to-not-found/GoToNotFound.jsx